import { memo, useCallback, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { Nullable } from 'cng-common/models/utils'

import { ContactDeactivationStep } from '../../../configs'
import { useReassignment } from '../../../contexts'
import { ContactDeactivationStepProps, ReassignmentItem } from '../../../models'
import { contactDeactivationModalTranslations } from '../../../translation'
import { Reassignment } from '../../reassignment'

export const ReassignFlagsStep = memo<ContactDeactivationStepProps>(({ onCancel, onProceed }) => {
  const { flagsToReassign, updateFlagAssignment } = useReassignment()

  const items: ReassignmentItem[] = useMemo(
    () =>
      flagsToReassign.map((flag) => ({
        key: flag.flag.code,
        displayName: flag.flag.code,
        contact: flag.contact,
      })),
    [flagsToReassign]
  )

  const handleProceedClick = useCallback(() => {
    onProceed(ContactDeactivationStep.Completion)
  }, [onProceed])

  const handleFlagChange = useCallback(
    (flagKey: string, contact: Nullable<IContact>) => {
      updateFlagAssignment(flagKey, contact)
    },
    [updateFlagAssignment]
  )

  return (
    <Reassignment
      title={contactDeactivationModalTranslations.reassignFlagsStep.title}
      description={contactDeactivationModalTranslations.reassignFlagsStep.description}
      items={items}
      onItemChange={handleFlagChange}
      onCancel={onCancel}
      onProceed={handleProceedClick}
    />
  )
})

ReassignFlagsStep.displayName = 'ReassignFlagsStep'

ReassignFlagsStep.displayName = 'ReassignFlagsStep'
